import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export const InstallAppButton = () => {
  const [prompt, setPrompt] = useState(() => window.__pgfInstallPrompt || null);

  useEffect(() => {
    const onAvailable = () => setPrompt(window.__pgfInstallPrompt || null);
    const onDone = () => setPrompt(null);
    window.addEventListener("pgf-install-available", onAvailable);
    window.addEventListener("pgf-install-done", onDone);
    return () => {
      window.removeEventListener("pgf-install-available", onAvailable);
      window.removeEventListener("pgf-install-done", onDone);
    };
  }, []);

  if (!prompt) return null;

  const install = async () => {
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") {
      window.__pgfInstallPrompt = null;
      setPrompt(null);
    }
  };

  return (
    <button type="button" data-testid="install-app-button" onClick={install}
      className="mt-3 w-full h-12 flex items-center justify-center gap-2 bg-[#0F1520] border border-emerald-500/40 text-emerald-300 font-medium rounded-xl hover:bg-emerald-500/10 transition-colors">
      <Download className="w-4 h-4" /> Instalar app
    </button>
  );
};
